import {date4api} from '@/providers/fields'
import IntervalSelector from './assets/IntervalSelector'

export var time_intervals = [
  '1h',
  '12h',
  '24h',
  'week',
  'month',
  'year',
];

export default {
  props: {
    id: {required: true},
    grid: {required: true},
    devices: {required: true},
  },
}

export var times = {
  components: {IntervalSelector},
  data () {return {
    now: new Date(), //avoid recomputing date for now
    time_interval: '24h',
  }},
  computed: {
    graph_interval () {
      if (this.resolution === 0) {
        return 'point';
      }
      if (!(this.resolution % (24*3600))) {
        return 'days';
      }
      if (!(this.resolution % 3600)) {
        return 'hours';
      }
      return 'interval';
    },
    resolution () {
      switch (this.time_interval) {
        case '1h':
        case '12h':
        case '24h':
          return 0;
        case 'week':
          return 6*3600; //6-hour intervals
        case 'month':
        case 'year':
          return 24*3600; //daily intervals

        throw "Unsupported time interval";
      }
    },
    resolution_filter () {
      if (!this.resolution) {
        return '';
      }

      var from = this.date_limits[0];
      from.setSeconds(0);
      from.setMinutes(0);

      //resolution is in full days -> start interval at midnight
      if (!(this.resolution % 24*3600)) {
        from.setHours(0);

      //resolution is in full hours -> interval depends
      } else if (!(this.resolution % 3600)) {
        var interval_hours = this.resolution / 3600;
        //if day can be split into N intervals, change the hour to the nearest lower interval point e.g. 00, 06, 12, 18
        if (24 % interval_hours) {
          var h = Math.floor(from.getHours() / interval_hours) * interval_hours;
          from.setHours(h);
        }
      }
      return 'date_from=' + date4api(from) +
          '&date_to=' + date4api(this.date_limits[1]) +
          '&interval=' + this.resolution
      ;
    },
    date_limits () {
      var ms;
      var dayms = 24 * 3600 * 1000;
      switch (this.time_interval) {
        case '1h':
          ms = 3600 * 1000;
          break;
        case '12h':
          ms = 12 * 3600 * 1000;
          break;
        case '24h':
          ms = dayms;
          break;
        case 'week':
          ms = 7*dayms;
          break;
        case 'month':
          ms = 30*dayms;
          break;
        case 'year':
          ms = 365*dayms;
          break;
        default:
          alert('Invalid interval');
          ms = 3600 * 1000;
          break;
      }
      return [new Date(this.now.getTime() - ms), this.now];
    },
    date_range_filter () {
      var limit = 'created_at::mr::' + date4api(this.date_limits[0]);
      if (this.date_limits[1] !== this.now) {
        limit += ',created_at::ls::' + date4api(this.date_limits[1]);
      }
      return limit;
    },
  },
  methods: {
    reload () {
      var time = new Date();
      if (Math.abs(time.getTime() - this.now.getTime()) > 10000) {  //allow updating every 10 seconds
        this.now = new Date();
      }
    },
  },
};


// WEBPACK FOOTER //
// ./src/apps/feelgrid/mixins.js